export var AvatarIndicatorVariant = /*#__PURE__*/ function(AvatarIndicatorVariant) {
    AvatarIndicatorVariant["status"] = "status";
    AvatarIndicatorVariant["custom"] = "custom";
    return AvatarIndicatorVariant;
}({});
export var AvatarIndicatorStatus = /*#__PURE__*/ function(AvatarIndicatorStatus) {
    AvatarIndicatorStatus["online"] = "online";
    AvatarIndicatorStatus["offline"] = "offline";
    return AvatarIndicatorStatus;
}({});
//? Avatar Add Button
export var AvatarAddButtonSize = /*#__PURE__*/ function(AvatarAddButtonSize) {
    AvatarAddButtonSize["xs"] = "xs";
    AvatarAddButtonSize["s"] = "s";
    AvatarAddButtonSize["m"] = "m";
    return AvatarAddButtonSize;
}({});
